import { render, staticRenderFns } from "./FormUserProfile.vue?vue&type=template&id=938c13a8&"
import script from "./FormUserProfile.vue?vue&type=script&lang=js&"
export * from "./FormUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports